export default "__VITE_ASSET__BYOlI5uV__"